// Shared support contact bits for the public marketing surfaces.
//
// Lived at `src/routes/_home/-contact.tsx` (the `-` prefix is how TanStack Router
// is told to ignore a file) while `_home` was the only surface with a footer.
// `SiteFooter` moved out of that layout when the blog took it, and the blog is
// deliberately NOT under `_home` — so the import was the one line left crossing a
// boundary the rest of the extraction was careful about (#814 review). It sits
// next to its only consumer now.

export const SUPPORT_EMAIL = "support@goodsender.com";

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

/**
 * Footer "Contact Us" link — same styling on every public-marketing footer.
 * Edit here, not at the call sites.
 */
export function ContactUsLink({ className = "" }: { className?: string }) {
  return (
    <a
      href={SUPPORT_MAILTO}
      className={`no-underline text-[color:var(--gs-muted)] hover:text-[color:var(--gs-text)] transition-colors ${className}`.trim()}
    >
      Contact Us →
    </a>
  );
}
